import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, mediaQuery, border, font } = baseVariables;

export const StyledAddHotelForm = styled.div`
  padding: ${toRem(40)} ${toRem(16)};
  border: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
  border-radius: ${toRem(12)};
  background-color: ${color.base20};
  box-shadow: 0 0 ${toRem(8)} 0 rgba(0, 0, 0, 0.07);

  .icon-calendar {
    font-size: ${toRem(20)};
    position: absolute;
    right: ${toRem(12)};
    top: ${toRem(10)};
    left: auto;
  }

  .calendar-modal {
    position: absolute;
    width: auto;
    z-index: 1;

    .DayPicker {
      .DayPicker-wrapper {
        padding: ${toRem(16)};
        .DayPicker-Months {
          .DayPicker-Month {
            margin: 0;
            .DayPicker-Day--selected {
              .DayPicker-Day-Cell {
                .DayPicker-Day-value {
                  background: ${color.merch30} !important;
                  border-radius: 50% !important;
                  color: ${color.base20} !important;
                }
              }
            }
          }
        }
      }
    }
  }

  .add-hotel-cta {
    font-size: ${font.fontS};
  }

  @media ${mediaQuery.md} {
    padding: ${toRem(40)};
  }
`;
